import { Logo } from "@/components/Logo";
import { useSmartNav } from "@/lib/scroll";

export default function NotFound() {
    const go = useSmartNav();

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-ink px-5 text-center" data-testid="not-found-page">
            <Logo />
            <div className="text-glow mt-12 bg-gradient-to-r from-volt to-blue-500 bg-clip-text font-syne text-7xl font-extrabold text-transparent sm:text-8xl">
                404
            </div>
            <p className="mt-5 max-w-md text-base text-slate-400">
                This page drifted off the grid. Let's get you back to solid ground.
            </p>
            <button
                data-testid="not-found-home-btn"
                onClick={() => go("/")}
                className="mt-9 rounded-full bg-volt px-7 py-3.5 font-mono text-xs font-bold uppercase tracking-[0.15em] text-[#07090E] transition-all duration-300 hover:shadow-[0_0_40px_rgba(0,240,255,0.45)]"
            >
                Back to Home
            </button>
        </div>
    );
}
